const Suffixes = [
    { id: 'Sr', name: 'Sr' },
    { id: 'Jr', name: 'Jr' },
    { id: 'III', name: 'III' },
];

export default Suffixes;



// WEBPACK FOOTER //
// ./src/models/Suffixes.ts